/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Grid, Dialog, DialogTitle, DialogActions, DialogContent, TextField,
   Checkbox, FormControlLabel,
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import Loading from '../../components/loading/Loading';
import FlashContext from '../../components/contexts/FlashContext';
import Select from 'react-select';

const selectStyles = {
  control: provided => ({ ...provided, height: 60, minHeight: 60 }),
  menu: provided => ({ ...provided, zIndex: 9999 }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const statusOptions = [
  { value: 'AwaitingPayment', label: 'Aguardando Pagamento' },
  { value: 'Settled', label: 'Paga' },
  { value: 'Canceled', label: 'Cancelada' },
];

const stateOptions = [
  {
    label: 'AC',
    value: 'AC',
  },
  {
    label: 'AP',
    value: 'AP',
  },
  {
    label: 'AM',
    value: 'AM',
  },
  {
    label: 'BA',
    value: 'BA',
  },
  {
    label: 'CE',
    value: 'CE',
  },
  {
    label: 'DF',
    value: 'DF',
  },
  {
    label: 'ES',
    value: 'ES',
  },
  {
    label: 'GO',
    value: 'GO',
  },
  {
    label: 'MA',
    value: 'MA',
  },
  {
    label: 'MT',
    value: 'MT',
  },
  {
    label: 'MS',
    value: 'MS',
  },
  {
    label: 'MG',
    value: 'MG',
  },
  {
    label: 'PA',
    value: 'PA',
  },
  {
    label: 'PB',
    value: 'PB',
  },
  {
    label: 'PR',
    value: 'PR',
  },
  {
    label: 'PE',
    value: 'PE',
  },
  {
    label: 'PI',
    value: 'PI',
  },
  {
    label: 'RJ',
    value: 'RJ',
  },
  {
    label: 'RN',
    value: 'RN',
  },
  {
    label: 'RS',
    value: 'RS',
  },
  {
    label: 'RO',
    value: 'RO',
  },
  {
    label: 'RR',
    value: 'RR',
  },
  {
    label: 'SC',
    value: 'SC',
  },
  {
    label: 'SP',
    value: 'SP',
  },
  {
    label: 'SE',
    value: 'SE',
  },
  {
    label: 'TO',
    value: 'TO',
  },
];

export default function CreateOrderDetail({
  openCreate, setOpenCreate, loadingCreate, handleCreate, handleClean,
  orderId, setOrderId, //order_id
  usercnpj, setUsercnpj, //cnpj_cpf
  nfseNumber, setNfseNumber, // invoice_number
  nfseSerie, setNfseSerie, // nfe_series
  status, setStatus, //status
  userName, setUserName, //client_name
  userEmail, setUserEmail, //email

  userCep, setuserCep, //postal_code
  streetName, setStreetName, //street_name
  houseNumber, setHouseNumber, //number
  complement, setComplement, //complement
  city, setCity, //city
  district, setDistrict, // district
  state, setState, //state

  value, setvalue, //amount e amount_paid
  pdf, setPdf, //gcs_pdf
  verificationCode, setverificationCode, //nfe_verification_code
  dateIssue, setDateIssue, //date_issue
}) {

  const { t } = useTranslation();
  const { notifyError } = useContext(FlashContext); 
  const [orderList, setOrderList] = useState([]);

  return (
    <Dialog onClose={() => setOpenCreate(false)} open={openCreate} fullWidth maxWidth="sm">
      <Loading open={loadingCreate} msg={'Salvando Nota Fiscal'} />
      <DialogTitle>Adicionar NFs</DialogTitle>
      <DialogContent>
        <Grid container spacing={3} style={{ justifyContent: 'center' }}>

          {/* Pedido */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='N° do Pedido'
              variant="outlined"
              value={orderId}
              onChange={e => setOrderId(e.target.value)}
            />
          </Grid>

        <Grid item sm={6} xs={12}>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                label="Data de Emissão"
                variant="inline"
                inputVariant="outlined"
                style={{ backgroundColor: '#fff' }}
                size="medium"
                format="dd/MM/yyyy"
                InputProps={{ readOnly: true }}
                InputAdornmentProps={{ position: 'start' }}
                value={dateIssue}
                onChange={date => setDateIssue(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          {/* N°Nfes */}
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              label='N° NFSe'
              variant="outlined"
              value={nfseNumber}
              onChange={e => setNfseNumber(e.target.value)}
            />
          </Grid>

          {/* Serie Nfse */}
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              label='Série NFSe'
              variant="outlined"
              value={nfseSerie}
              onChange={e => setNfseSerie(e.target.value)}
            />
          </Grid>

          {/* Cod. Verificação */}
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              label='Código de Verificação'
              variant="outlined"
              value={verificationCode}
              onChange={e => setverificationCode(e.target.value)}
            />
          </Grid>

          {/* Status */}
          <Grid item sm={6} xs={12}>
            <Select
              styles={selectStyles}
              value={statusOptions.find(opt => opt.value === status) || null}
              onChange={e => setStatus(e ? e.value : '')}
              placeholder="Status"
              menuPlacement="auto"
              options={statusOptions}
            />
          </Grid>

          {/* Valor */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='Valor'
              variant="outlined"
              value={value}
              onChange={e => setvalue(e.target.value)}
            />
          </Grid>

          {/* Valor Previsto */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='Nome do tomador'
              variant="outlined"
              value={userName}
              onChange={e => setUserName(e.target.value)}
            />
          </Grid>

          {/* CNPJ/CPF   */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='CNPJ/CPF'
              variant="outlined"
              value={usercnpj}
              onChange={e => setUsercnpj(e.target.value)}
            />
          </Grid>

          

          {/* Email */}
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='Email'
              variant="outlined"
              value={userEmail}
              onChange={e => setUserEmail(e.target.value)}
            />
          </Grid>

            <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='CEP'
              variant="outlined"
              value={userCep}
              onChange={e => setuserCep(e.target.value)}
            />
          </Grid>
        
          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='Rua'
              variant="outlined"
              value={streetName}
              onChange={e => setStreetName(e.target.value)}
            />
          </Grid>

          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='N°'
              variant="outlined"
              value={houseNumber}
              onChange={e => setHouseNumber(e.target.value)}
            />
          </Grid>

          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='Bairro'
              variant="outlined"
              value={district}
              onChange={e => setDistrict(e.target.value)}
            />
          </Grid>

          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='Complemento'
              variant="outlined"
              value={complement}
              onChange={e => setComplement(e.target.value)}
            />
          </Grid>

          <Grid item sm={6} xs={12}>
            <TextField
              fullWidth
              label='Cidade'
              variant="outlined"
              value={city}
              onChange={e => setCity(e.target.value)}
            />
          </Grid>

         <Grid item sm={6} xs={12}>
          <Select
            styles={selectStyles}
            value={stateOptions.find(opt => opt.value === state) || null}
            onChange={e => setState(e ? e.value : '')}
            placeholder="UF"
            menuPlacement="auto"
            options={stateOptions}
          />
          </Grid>

          <Grid item sm={12} xs={12}>
            <Button component="label" variant="outlined">
              {pdf?.name || 'Selecionar PDF'}
              <input
              fullWidth
              type= "file"
              hidden
              accept="application/pdf"
              onChange={e => setPdf(e.target.files[0] || null)}
              >

              </input>
            </Button>
          </Grid>

          

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button style={{ height: 40 }} onClick={handleClean} variant="text" color="primary">
          {t('billsToPay.createDialog.buttons.cancel')}
        </Button>
        <Button
          style={{ height: 40 }}
          onClick={handleCreate}
          disabled={loadingCreate}
          variant="contained"
          color="primary"
        >
          {t('billsToPay.createDialog.buttons.create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}